module.exports = __webpack_public_path__ + "static/carousel-hero-classic-2x-dc4f1c989ef1edc1b1001c99f2e0f52b.png";